import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDropLeftActive = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M23.8125 3.4375C23.8125 1.5918 22.2832 0.0625 20.4375 0.0625H3.5625C1.66406 0.0625 0.1875 1.5918 0.1875 3.4375V20.3125C0.1875 22.2109 1.66406 23.6875 3.5625 23.6875H20.4375C22.2832 23.6875 23.8125 22.2109 23.8125 20.3125V3.4375Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.875 11.5C16.875 10.9844 16.4531 10.5625 15.9375 10.5625H12.9375V7.5625C12.9375 7.04688 12.5156 6.625 12 6.625C11.4609 6.625 11.0625 7.04688 11.0625 7.5625V10.5625H8.0625C7.52344 10.5625 7.125 10.9844 7.125 11.5C7.125 12.0391 7.52344 12.4375 8.0625 12.4375H11.0625V15.4375C11.0625 15.9766 11.4609 16.375 12 16.375C12.5156 16.375 12.9375 15.9766 12.9375 15.4375V12.4375H15.9375C16.4531 12.4375 16.875 12.0391 16.875 11.5Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgDropLeftActive);
export { ForwardRef as ReactComponent };
